import { useEffect, useRef } from 'react'
import { useAtom } from 'jotai'
import * as state from '../states'
import { EFetchReloadKey } from '../types'
import { TIME, TIMEOUT_FETCH } from '../constants'
import * as helpers from '../helpers'

// default values for auto-refresh timers
const TIME_UPDATE: Record<EFetchReloadKey, number> = {
	[EFetchReloadKey.listAccountBuyer]: 10 * TIME.ONE_MIN, // one time in 10 min - 10 * TIME.ONE_MIN
	[EFetchReloadKey.listAccountTeam]: 10 * TIME.ONE_MIN, // one time in 10 min - 10 * TIME.ONE_MIN
	[EFetchReloadKey.listRevenueAgency]: 10 * TIME.ONE_MIN, // one time in 10 min - 10 * TIME.ONE_MIN
	[EFetchReloadKey.allParallelList]: TIME.ONE_HOUR, // one time 1 Hour - TIME.ONE_HOUR
	[EFetchReloadKey.allList]: TIME.ONE_DAY // not used now
}

type IUseCommonFetchAutoRefresh = {
	isEnabled: boolean
	reloadKeyName: EFetchReloadKey
}

// ['auto-refresh-update' logic for defined fetchers according to EFetchReloadKey]
export function useCommonFetchAutoRefresh({
	isEnabled,
	reloadKeyName
}: IUseCommonFetchAutoRefresh) {
	const [fetchIsCommonToReload, setFetchIsCommonToReload] = useAtom(state.fetchIsCommonToReloadAtom)
	const updatedAt = fetchIsCommonToReload[reloadKeyName].updatedAt
	const count = fetchIsCommonToReload[reloadKeyName].count

	const reloadTimer = useRef(0)
	const updateTime = TIME_UPDATE[reloadKeyName]

	// check condition - updateTime should not be less than FETCH_TIMEOUT
	// to avoid potential infinite unresolved/cancelled fetch requests
	if (updateTime < TIMEOUT_FETCH) {
		throw new Error(`hook.useCommonFetchAutoRefresh:: incorrect config for reloadKeyName = ${reloadKeyName}:\n    (updateTime: ${updateTime}ms) < (TIMEOUT_FETCH: ${TIMEOUT_FETCH}ms)`)
	}

	const launchAction = () => {
		switch (reloadKeyName) {
			case EFetchReloadKey.listAccountBuyer: {
				setFetchIsCommonToReload(state.launchUpdateListAccountBuyer)
				break
			}
			case EFetchReloadKey.listAccountTeam: {
				setFetchIsCommonToReload(state.launchUpdateListAccountTeam)
				break
			}
			case EFetchReloadKey.listRevenueAgency: {
				setFetchIsCommonToReload(state.launchUpdateListRevenueAgency)
				break
			}
			case EFetchReloadKey.allParallelList: {
				setFetchIsCommonToReload(state.launchUpdateAllParallelList)
				break
			}
			case EFetchReloadKey.allList: {
				setFetchIsCommonToReload(state.launchUpdateAllList)
				break
			}
			default: {
				throw new Error(`hook.useCommonFetchAutoRefresh:: No such case for reloadKeyName = ${reloadKeyName}`)
			}
		}
	}

	useEffect(() => {
		if (isEnabled) {
			//console.log(`useCommonFetchAutoRefresh - START - - ${reloadKeyName}`, { reloadTimer })
			reloadTimer.current = setInterval((() => {
				const now = helpers.getNowInMs()
				const nowFormat = new Date(now)
				const updatedAtFormat = updatedAt && new Date(updatedAt)
				//TODO: check the condition if necessary in the future ...?
				const launchCondition = true //!updatedAt || diff...

				/*console.log(`--- in setInterval - launchUpdate - ${reloadKeyName}`, {now, nowFormat, count, updatedAt, updatedAtFormat, launchCondition})*/

				if (launchCondition) {
					launchAction()
				}
			}) as TimerHandler, updateTime)

			return () => {
				//console.log(`*** clearInterval for reloadTimer - ${reloadKeyName}`)
				return clearInterval(reloadTimer.current)
			}
		}
	}, [updatedAt])
}